import { useTheme } from "../../../theme/ThemeProvider";
import { ITheme } from "../../../theme/ITheme";
import { IProfileStyles } from "../../styles";

export const useProfileStyles = (theme?: ITheme): IProfileStyles => {
    if (theme === undefined) {
        theme = useTheme();
    }

    return {
        profileContainer: {
            maxWidth: "100%",
            borderRadius: theme.shape.borderRadiusMd,
            border: `1px solid ${theme.palette.divider.light}`,
        },
        profileLink: {
            color: theme.palette.accent.light,
            fontSize: theme.font.sizes.sm,
            fontWeight: theme.font.weights.regular,
            lineHeight: theme.font.sizes.md,
        },
        profileInitials: {
            color: theme.palette.white,
            backgroundColor: theme.palette.accent.dark,
            borderColor: theme.palette.accent.dark,
            cursor: "pointer",
            fontSize: theme.font.sizes.xxl,
            lineHeight: theme.font.sizes.xxl,
        },
        profileText: {
            cursor: "pointer",
            color: theme.palette.text.main,
            fontSize: theme.font.sizes.md,
            lineHeight: theme.font.sizes.md,
            padding: 0,
        },
    }
}